import { jsxs as x, jsx as f, Fragment as O } from "react/jsx-runtime";
import { u as b } from "./index-6a632112.mjs";
import { useState as _, useRef as z, useCallback as sr, useEffect as lr } from "react";
import { s as p, r as S, d as R, a as dr, c as cr } from "./themes-5f0b3c3d.mjs";
import { l as I } from "./lineHeights-72d3110c.mjs";
import { t as V } from "./textStyles-42cab346.mjs";
import { Tooltip as q } from "./tooltip.js";
import "./fontWeights-a25f8f91.mjs";
import "./useWindowDimensions.js";
import "./zIndices-d07533f3.mjs";
import "./getElementPosition-5026bb28.mjs";
const E = ["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], j = ["ArrowUp", "ArrowRight"], ar = ["ArrowLeft", "ArrowDown"], fr = b.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
  width: 100%;
  position: relative;
  .thumb,
  .thumb::-webkit-slider-thumb {
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
  }

  .thumb {
    pointer-events: none;
    position: absolute;
    height: 0;
    width: 100%;
    outline: none;
  }

  .thumb::-webkit-slider-thumb {
    background-color: ${(o) => o.theme.components.slider.backgroundColor};
    border: 2px solid ${(o) => o.theme.components.slider.borderColor};
    border-radius: 50%;
    ${(o) => !o.$isDisabled && "cursor: pointer"};
    height: ${p["6x"]};
    width: ${p["6x"]};
    margin-top: unset;
    pointer-events: all;
    position: relative;

    &:hover {
      background-color: ${(o) => o.theme.components.slider.thumbHoverBackgroundColor};
    }

    &:active {
      background-color: ${(o) => o.theme.components.slider.thumbActiveBackgroundColor};
    }
  }

  .thumb:focus-visible::-webkit-slider-thumb {
    outline: 3px solid ${(o) => o.theme.components.slider.focusColor};
    outline-offset: 2px;
  }

  input:disabled {
    &.thumb::-webkit-slider-thumb {
      background-color: ${(o) => o.theme.components.slider.backgroundColor};
      border: 2px solid
        ${(o) => o.theme.components.slider.borderColorDisabled};

      &:hover {
        background-color: ${(o) => o.theme.components.slider.backgroundColor};
        pointer: none;
      }
    }
  }

  .thumb::-moz-range-thumb {
    background-color: ${(o) => o.theme.components.slider.backgroundColor};
    border: none;
    border-radius: 50%;
    cursor: pointer;
    height: ${p["6x"]};
    width: ${p["6x"]};
    margin-top: unset;
    pointer-events: all;
    position: relative;

    &:hover {
      background-color: ${(o) => o.theme.components.slider.thumbHoverBackgroundColor};
    }

    &:active {
      background-color: ${(o) => o.theme.components.slider.thumbActiveBackgroundColor};
    }
  }
`, K = b.input`
  z-index: ${(o) => o.$inputType === "first" ? "3" : "4"};
  ${(o) => o.$inputType === "first" && !Array.isArray(o.$sliderValue) && "display: none"};
  margin-left: ${(o) => o.$inputType === "first" ? "-2px" : "0px"};
`, pr = b.div`
  position: relative;
  width: 100%;
  margin: ${p["3x"]} 0px;
  .tooltip-left {
    width: 100%;
    position: absolute;
    div[role='tooltip'] {
      /* Calculating tooltip left position */
      left: ${({ $minValue: o, $max: l, $min: s, $getPercent: $ }) => {
  const h = $(o);
  return o < (s + l) / 2 ? `calc(1% + ${h}%)` : `calc(-1% + ${h}%)`;
}};
      bottom: 35px;
    }
  }
  .tooltip-right {
    width: 100%;
    position: absolute;
    div[role='tooltip'] {
      left: ${({ $maxValue: o, $max: l, $min: s, $getPercent: $ }) => {
  const h = $(o);
  return o < (s + l) / 2 ? `calc(1% + ${h}%)` : `calc(-1% + ${h}%)`;
}};
      bottom: 35px;
    }
  }
`, yr = b.div`
  background-color: ${(o) => o.$isDisabled ? o.theme.components.slider.disabledBackgroundColor : o.theme.components.slider.sliderTrackBackgroundColor};
  border-radius: ${S["2x"]};
  height: ${p["1x"]};
  width: 100%;
  position: absolute;
  z-index: 1;
  width: 100%;
`, mr = b.div`
  background-color: ${(o) => o.$isDisabled ? o.theme.components.slider.disabledBackgroundColor : o.theme.components.slider.sliderRangeBackgroundColor};
  border-radius: ${S["2x"]};
  height: ${p["1x"]};
  position: absolute;
  z-index: 2;
`, G = b.div`
  display: flex;
  box-sizing: border-box;
  border-radius: ${S["2x"]};
  border: ${p.px} solid
    ${(o) => o.theme.components.slider.inputBorderColor};
  background: ${(o) => o.$isDisabled ? o.theme.components.slider.disabledInputBackgroundColor : o.theme.components.slider.backgroundColor};
  width: 88px;
  padding: ${p["1x"]} ${p["3x"]};
  align-items: center;
  justify-content: center;
  margin: ${p.px};

  &.input-focus {
    border: 2px solid
      ${(o) => o.theme.components.slider.thumbActiveBackgroundColor};
    margin: unset;
  }
`, ur = b.div`
  display: flex;
  flex-direction: ${(o) => Array.isArray(o.value) && o.$category === "inputField" ? "column" : "row"};
  justify-content: space-between;
  width: 100%;
  margin-bottom: ${p["4x"]};
  font-family: ${R.body};
  font-size: ${V.body.medium.m.fontSize};
  font-style: normal;
  font-weight: ${V.body.regular.m.fontWeight};
  line-height: ${I.xsmall};
  color: ${(o) => o.theme.components.slider.labelTextColor};
  ${(o) => !Array.isArray(o.value) && "align-items: center"};
`, br = b.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-family: ${R.body};
  font-size: ${V.body.medium.s.fontSize};
  font-style: normal;
  font-weight: ${V.body.regular.m.fontWeight};
  line-height: ${I.small};
  color: ${(o) => o.$isDisabled ? o.theme.components.slider.disableLabelTextColor : o.theme.components.slider.textColorFilled};
  ${(o) => !o.$isDiscrete && `margin-top : ${p["2x"]};`};
  padding: 0 4px;
`, J = b.div``, $r = b.div`
  display: flex;
  justify-content: space-between;
`, hr = b.span`
  width: 2px;
  height: 6px;
  background: ${(o) => o.$isDisabled ? o.theme.components.slider.borderColorDisabled : o.theme.components.slider.sliderTickColor};
  border-radius: ${S["0x"]} ${S["0x"]} ${S["2x"]} ${S["2x"]};
`, gr = b.div`
  display: flex;
  justify-content: space-between;
  width: calc(100% - ${p["6x"]});
  margin-bottom: ${p["2x"]};
  margin-left: 2px;
  margin-top: -6px;
`, Ar = b.div`
  ${(o) => Array.isArray(o.value) && o.$category === "inputField" && `margin-bottom: ${p["2x"]};`};
  font-family: ${R.body};
  font-size: ${V.body.medium.m.fontSize};
  font-style: normal;
  font-weight: ${V.body.medium.m.fontWeight};
  line-height: ${I.medium};
  color: ${(o) => o.theme.components.slider.labelTextColor};
`, xr = b.div`
  ${(o) => Array.isArray(o.value) && o.$category === "inputField" && `margin-bottom: ${p["2x"]};`};
  font-family: ${R.body};
  font-size: ${V.body.medium.m.fontSize};
  font-style: normal;
  font-weight: ${V.body.regular.m.fontWeight};
  line-height: ${I.medium};
  color: ${(o) => o.$isDisabled ? o.theme.components.slider.disableLabelTextColor : o.theme.components.slider.labelTextColor};
`, Q = b.input`
  width: 100%;
  letter-spacing: unset;
  font-size: ${dr.small};
  background-color: transparent;
  color: ${(o) => o.$isDisabled ? o.theme.components.slider.disableTextColor : o.theme.components.slider.textColorFilled};
  border-style: none;
  outline-style: none;
  font-style: normal;
  font-weight: ${V.body.regular.m.fontWeight};
  line-height: ${I.medium};
`;
function Nr({
  min: o = 0,
  max: l = 100,
  isDiscrete: s = !1,
  steps: $ = 10,
  category: h = "tooltip",
  label: P,
  onChange: d,
  isDisabled: m = !1,
  value: t,
  isRequired: W = !1,
  showRequiredIndicator: X = W
}) {
  const c = (r) => {
    const e = (l - o) / $;
    let n = o;
    if (r < o)
      return o;
    if (r > l)
      return l;
    for (let i = 0; i < $; i++) {
      const y = n;
      if (n = n + e, r <= n)
        return r < y + e / 2 ? y : n;
    }
    return n;
  }, Y = Array.isArray(t) ? s ? c(t[0]) : t[0] : 0, Z = Array.isArray(t) ? s ? c(t[1]) : t[1] : t, [g, A] = _(Y), [a, u] = _(Z), C = z(null), L = z(null), M = z(null), w = z(null), k = z(null), D = Array.from(Array($ + 1), (r, e) => e + 1), T = sr(
    (r) => Math.round((r - o) / (l - o) * 100),
    [o, l]
  ), v = (r) => {
    r[1] > l && d(null, [r[0], l]), r[0] < o && d(null, [o, r[1]]), r[1] < r[0] && d(null, [r[0], r[0]]), r[0] > r[1] && d(null, [r[1], r[1]]);
  }, rr = (r) => {
    if (L.current && Array.isArray(r) && r[0] >= 0) {
      const e = Array.isArray(r) ? s ? c(r[0]) : r[0] : o, n = T(e), i = T(+L.current.value);
      M.current && (M.current.style.left = `${n}%`, M.current.style.width = `${i - n}%`, A(s ? c(r[0]) : r[0]));
    }
  }, tr = (r) => {
    if (C.current && (Array.isArray(r) ? r[1] >= 0 : r >= 0)) {
      const e = T(+C.current.value), n = Array.isArray(r) ? s ? c(r[1]) : r[1] : r, i = T(n);
      M.current && (M.current.style.width = `${i - e}%`, Array.isArray(r) ? u(r[1]) : u(r));
    }
  };
  lr(() => {
    !Array.isArray(t) && (t < o || t > l) ? (t < o && d(null, o), t > l && d(null, l)) : Array.isArray(t) && (t[1] < t[0] || t[0] > t[1] || t[0] < o || t[1] > l) ? v(t) : (rr(t), tr(t));
  }, [t, T, o, l, s, $]);
  const or = (r) => {
    if (r.target.value === "-" || r.target.value === "") {
      const e = r.target.value;
      u(e);
    } else
      isNaN(+r.target.value) || u(+r.target.value);
  }, er = (r) => {
    if (r.target.value === "-" || r.target.value === "") {
      const e = r.target.value;
      A(e);
    } else
      isNaN(+r.target.value) || A(+r.target.value);
  }, F = (r) => {
    if (g === "" || g === "-")
      A(Array.isArray(t) ? t[0] : o);
    else if (typeof g == "number" && Array.isArray(t))
      if (g > t[1] || g < o) {
        const e = g > t[1] ? t[1] : g < o ? o : t[0], n = [...t];
        n[0] = e, d(r, n), A(e);
      } else if (s) {
        const e = c(g);
        d(r, [e, t[1]]), A(c(t[0]));
      } else
        d(r, [g, t[1]]);
  }, H = (r) => {
    if (a === "" || a === "-")
      u(Array.isArray(t) ? t[1] : t);
    else if (typeof a == "number" && Array.isArray(t))
      if (a < t[0] || a > l) {
        const e = a < t[0] ? t[0] : l;
        d(r, [t[0], e]), u(e);
      } else
        s ? (d(r, [t[0], c(a)]), u(c(a))) : d(r, [t[0], a]);
    else if (typeof a == "number" && !Array.isArray(t))
      if (a < o || a > l) {
        const e = a < o ? o : l;
        d(r, e), u(e);
      } else
        s ? (d(r, c(a)), u(c(a))) : d(r, a);
  }, U = (r) => !(!isNaN(r) && Math.abs(r % 1) === 0 || r === "-"), B = (r, e, n, i) => {
    let y = i === "min" ? e[0] : e[1];
    if (y = j.includes(r.code) ? y + n : y - n, i == "min") {
      if (e[0] === e[1] && j.includes(r.code))
        return;
      d(r, [y, e[1]]), A(y);
    } else {
      if (e[0] === e[1] && ar.includes(r.code))
        return;
      d(r, [e[0], y]), u(y);
    }
  }, N = (r, e, n) => {
    let i = e;
    i = j.includes(r.code) ? i + n : i - n, d(r, i), u(i);
  }, ir = (r, e, n) => {
    if (s) {
      const i = c(r);
      i !== n[1] && d(e, [n[0], i]), u(i);
    } else
      d(e, [n[0], r]), u(r);
  }, nr = (r, e, n) => {
    if (s) {
      const i = c(r);
      i !== n && d(e, i), u(i);
    } else
      d(e, r), u(r);
  };
  return /* @__PURE__ */ x(fr, { $isDisabled: m, children: [
    /* @__PURE__ */ x(ur, { value: t, $category: h, children: [
      P && /* @__PURE__ */ x(Ar, { value: t, $category: h, children: [
        P,
        X && /* @__PURE__ */ x(
          "span",
          {
            "aria-hidden": "true",
            style: { color: cr.utilityDanger[1e3] },
            children: [
              " ",
              "*"
            ]
          }
        )
      ] }),
      h === "inputField" && /* @__PURE__ */ x($r, { children: [
        Array.isArray(t) && /* @__PURE__ */ f(G, { $isDisabled: m, children: /* @__PURE__ */ f(
          Q,
          {
            id: "min-value",
            type: "text",
            "aria-required": W,
            ref: w,
            $isDisabled: m,
            value: g,
            onChange: er,
            onKeyPress: (r) => {
              U(r.key) && r.preventDefault(), (r.code === "Escape" || r.code === "Enter") && F(r);
            },
            onBlur: (r) => F(r)
          }
        ) }),
        /* @__PURE__ */ f(G, { $isDisabled: m, children: /* @__PURE__ */ f(
          Q,
          {
            id: "max-value",
            type: "text",
            "aria-required": W,
            ref: k,
            $isDisabled: m,
            value: a,
            onChange: or,
            onKeyPress: (r) => {
              U(r.key) && r.preventDefault(), (r.code === "Escape" || r.code === "Enter") && H(r);
            },
            onBlur: (r) => H(r)
          }
        ) })
      ] }),
      h === "tooltip" && /* @__PURE__ */ f(
        xr,
        {
          value: t,
          $category: h,
          $isDisabled: m,
          children: Array.isArray(t) ? s ? `${c(
            t[0]
          )} - ${c(t[1])}` : `${t[0]} - ${t[1]}` : `${t}`
        }
      )
    ] }),
    /* @__PURE__ */ x(
      pr,
      {
        $minValue: Array.isArray(t) ? s ? c(t[0]) : t[0] : o,
        $maxValue: Array.isArray(t) ? s ? c(t[1]) : t[1] : t,
        $min: o,
        $max: l,
        $getPercent: T,
        children: [
          h === "tooltip" ? /* @__PURE__ */ x(O, { children: [
            /* @__PURE__ */ f(
              q,
              {
                placement: "auto",
                title: Array.isArray(t) ? s ? c(t[0]).toString() : t[0].toString() : o.toString(),
                className: "tooltip-left",
                isDisabled: m,
                children: /* @__PURE__ */ f(
                  K,
                  {
                    type: "range",
                    min: o,
                    max: l,
                    value: Array.isArray(t) ? s ? c(t[0]) : t[0] : o,
                    ref: C,
                    onChange: (r) => {
                      const e = Array.isArray(t) ? t[1] : t || 100, n = Math.min(+r.target.value, e - 1);
                      if (Array.isArray(t))
                        if (s) {
                          const i = c(n);
                          i !== t[0] && d(r, [i, t[1]]);
                        } else
                          d(r, [n, t[1]]);
                      r.target.value = t.toString();
                    },
                    onKeyDown: (r) => {
                      if (E.includes(r.code) && s) {
                        const e = (l - o) / $;
                        Array.isArray(t) ? B(r, t, e, "min") : N(r, t, e), r.preventDefault();
                      }
                    },
                    $inputType: "first",
                    className: "thumb",
                    $sliderValue: t
                  }
                )
              }
            ),
            /* @__PURE__ */ f(
              q,
              {
                placement: "auto",
                title: Array.isArray(t) ? s ? c(t[1]).toString() : t[1].toString() : t.toString(),
                className: "tooltip-right",
                isDisabled: m,
                children: /* @__PURE__ */ f(
                  K,
                  {
                    type: "range",
                    min: o,
                    max: l,
                    disabled: m,
                    value: Array.isArray(t) ? s ? c(t[1]) : t[1] : t,
                    ref: L,
                    onChange: (r) => {
                      const e = Array.isArray(t) ? t[0] : o || 0, n = Array.isArray(t) ? e + 1 : e, i = Math.max(+r.target.value, n);
                      if (Array.isArray(t))
                        if (s) {
                          const y = c(i);
                          y !== t[1] && d(r, [t[0], y]);
                        } else
                          d(r, [t[0], i]);
                      else if (s) {
                        const y = c(i);
                        y !== t && d(r, y);
                      } else
                        d(r, i);
                      r.target.value = t.toString();
                    },
                    onKeyDown: (r) => {
                      if (E.includes(r.code) && s) {
                        const e = (l - o) / $;
                        Array.isArray(t) ? B(r, t, e, "max") : N(r, t, e), r.preventDefault();
                      }
                    },
                    "aria-label": "max-input",
                    $inputType: "second",
                    className: "thumb",
                    $sliderValue: t
                  }
                )
              }
            )
          ] }) : /* @__PURE__ */ x(O, { children: [
            /* @__PURE__ */ f(
              K,
              {
                type: "range",
                min: o,
                max: l,
                disabled: m,
                value: Array.isArray(t) ? s ? c(t[0]) : t[0] : o,
                ref: C,
                onChange: (r) => {
                  w.current && w.current.parentElement?.classList.add(
                    "input-focus"
                  );
                  const e = Array.isArray(t) ? t[1] : t || 100, n = Math.min(+r.target.value, e - 1);
                  if (Array.isArray(t))
                    if (s) {
                      const i = c(n);
                      i !== t[0] && d(r, [i, t[1]]), A(i);
                    } else
                      d(r, [n, t[1]]), A(n);
                  r.target.value = t.toString();
                },
                onMouseOut: () => {
                  k.current && w.current && (k.current.parentElement?.classList.remove(
                    "input-focus"
                  ), w.current.parentElement?.classList.remove(
                    "input-focus"
                  ));
                },
                onKeyDown: (r) => {
                  if (E.includes(r.code) && s) {
                    const e = (l - o) / $;
                    Array.isArray(t) ? B(r, t, e, "min") : N(r, t, e), r.preventDefault();
                  }
                },
                $inputType: "first",
                className: "thumb",
                $sliderValue: t
              }
            ),
            /* @__PURE__ */ f(
              K,
              {
                type: "range",
                min: o,
                max: l,
                disabled: m,
                value: Array.isArray(t) ? s ? c(t[1]) : t[1] : t,
                ref: L,
                onChange: (r) => {
                  k.current && k.current.parentElement?.classList.add(
                    "input-focus"
                  );
                  const e = Array.isArray(t) ? t[0] : o || 0, n = Array.isArray(t) ? e + 1 : e, i = Math.max(+r.target.value, n);
                  Array.isArray(t) ? ir(i, r, t) : nr(i, r, t), r.target.value = t.toString();
                },
                onMouseOut: (r) => {
                  (k.current && w.current || !Array.isArray(t)) && (k?.current?.parentElement?.classList.remove(
                    "input-focus"
                  ), w?.current?.parentElement?.classList.remove(
                    "input-focus"
                  ));
                },
                onKeyDown: (r) => {
                  if (E.includes(r.code) && s) {
                    const e = (l - o) / $;
                    Array.isArray(t) ? B(r, t, e, "max") : N(r, t, e), r.preventDefault();
                  }
                },
                "aria-label": "max-input",
                $inputType: "second",
                className: "thumb",
                $sliderValue: t
              }
            )
          ] }),
          /* @__PURE__ */ f(yr, { $isDisabled: m }),
          /* @__PURE__ */ f(mr, { $isDisabled: m, ref: M })
        ]
      }
    ),
    s && /* @__PURE__ */ f(gr, { children: D.map(
      (r, e) => r && /* @__PURE__ */ f(hr, { $isDisabled: m }, e)
    ) }),
    /* @__PURE__ */ x(br, { $isDiscrete: s, $isDisabled: m, children: [
      /* @__PURE__ */ f(J, { children: o }),
      /* @__PURE__ */ f(J, { children: l })
    ] })
  ] });
}
export {
  Nr as Slider
};
